import React from 'react';

interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    return <div className="min-h-screen">{children}</div>;
};

Layout.displayName = 'Layout';
export default Layout;
